export default __webpack_public_path__ + "099ece5398b5bf35a1da60a6cc0fad38.svg";